export default {
  'pages.setting.dept.title': 'Department Management',
  'pages.setting.dept.subtitle': 'Organize and manage company departments',
  'pages.setting.dept.searchPlaceholder': 'Search by department name or code',
  // Table columns
  'pages.setting.dept.column.deptName': 'Department',
  'pages.setting.dept.column.deptCode': 'Code',
  'pages.setting.dept.column.email': 'Email',
  'pages.setting.dept.column.phone': 'Phone',
  'pages.setting.dept.column.memberCount': 'Members',
  'pages.setting.dept.column.status': 'Status',
  'pages.setting.dept.column.operation': 'Operation',
  // Status
  'pages.setting.dept.status.enabled': 'Enabled',
  'pages.setting.dept.status.disabled': 'Disabled',
  // Actions
  'pages.setting.dept.add': 'Add Department',
  'pages.setting.dept.edit': 'Edit',
  'pages.setting.dept.addChild': 'Add',
  // Modal titles
  'pages.setting.dept.modal.addTitle': 'Add Department',
  'pages.setting.dept.modal.editTitle': 'Edit Department',
  // Form
  'pages.setting.dept.form.deptName': 'Department Name',
  'pages.setting.dept.form.deptNamePlaceholder': 'Please enter department name',
  'pages.setting.dept.form.deptNameRequired': 'Please enter department name',
  'pages.setting.dept.form.deptCode': 'Department Code',
  'pages.setting.dept.form.deptCodePlaceholder': 'Please enter department code',
  'pages.setting.dept.form.deptCodeRequired': 'Please enter department code',
  'pages.setting.dept.form.deptCodePattern': 'Department code can only contain letters, numbers and underscores',
  'pages.setting.dept.form.deptCodeExists': 'Department code already exists',
  'pages.setting.dept.form.leader': 'Leader',
  'pages.setting.dept.form.leaderPlaceholder': 'Please enter department leader',
  'pages.setting.dept.form.leaderRequired': 'Please enter department leader',
  'pages.setting.dept.form.parentId': 'Parent Department',
  'pages.setting.dept.form.parentIdPlaceholder': 'Please select parent department',
  'pages.setting.dept.form.email': 'Email',
  'pages.setting.dept.form.emailPlaceholder': 'Please enter email address',
  'pages.setting.dept.form.emailInvalid': 'Please enter a valid email address',
  'pages.setting.dept.form.phone': 'Phone',
  'pages.setting.dept.form.phonePlaceholder': 'Please enter phone number',
  'pages.setting.dept.form.phoneInvalid': 'Please enter a valid Philippines phone number',
  'pages.setting.dept.form.orderNum': 'Sort Order',
  'pages.setting.dept.form.orderNumPlaceholder': 'Please enter sort order',
  'pages.setting.dept.form.status': 'Status',
  'pages.setting.dept.form.statusRequired': 'Please select status',
  'pages.setting.dept.form.remark': 'Description',
  'pages.setting.dept.form.remarkPlaceholder': 'Please enter remark',
  // Messages
  'pages.setting.dept.message.deleteSuccess': 'Deleted successfully',
  'pages.setting.dept.message.deleteRejected': 'Cannot delete: this department still has users or sub-departments',
  'pages.setting.dept.message.deleteFailed': 'Delete failed',
  'pages.setting.dept.message.addSuccess': 'Added successfully',
  'pages.setting.dept.message.editSuccess': 'Updated successfully',
};
